import React, { useRef, useEffect, useReducer } from "react";

// Components imports
import LegalEntityBasicData from "./components/LegalEntityBasicData";
import IndividualBasicData from "./components/IndividualBasicData/IndividualBasicData";
import ChooseAccountType from "./components/ChooseAccountType";
import PrevNextButtonsContainer from "../../components/common/PrevNextButtonsContainer";
import Address from "./components/Address";
import Contact from "./components/Contact";
import DataVerification from "./components/DataVerification";

// Scss imports
import css from "./MultiStepForm.module.scss";

interface MultiStepFormProps {
  currentStep: number;
  setCurrentStep: Function;
  handleSubmit: Function;
  accountType: string;
  setAccountTypeToLegalEntity: Function;
  setAccountTypeToIndividual: Function;
  isButtonDisabled: any;
  buttonLegalClicked: boolean;
  buttonIndividualClicked: boolean;
  firstName: string;
  lastName: string;
  nationalId: string;
  identificationNumber: string;
  taxId: string;
  identificationNumberE: string;
  taxIdE: string;
  businessName: string;
  handleChange: Function;
  place: string;
  street: string;
  buildingNumber: number;
  letter: string;
  floor: number;
  apartmentNumber: number;
  municipality: string;
  zipCode: number;
  email: string;
  phone: string;
  nextButtonClickHandler: Function;
  disabledButton: boolean;
  error?: any;
}

const MultiStepForm: React.FC<MultiStepFormProps> = ({
  currentStep,
  setCurrentStep,
  handleSubmit,
  accountType,
  setAccountTypeToLegalEntity,
  setAccountTypeToIndividual,
  isButtonDisabled,
  buttonLegalClicked,
  buttonIndividualClicked,
  firstName,
  lastName,
  nationalId,
  identificationNumber,
  taxId,
  identificationNumberE,
  taxIdE,
  businessName,
  place,
  street,
  buildingNumber,
  letter,
  floor,
  apartmentNumber,
  municipality,
  zipCode,
  email,
  phone,
  handleChange,
  nextButtonClickHandler,
  disabledButton,
  error,
}) => {
  // Defining refs
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const legalEntityButtonRef = useRef(null);
  const individualButtonRef = useRef(null);

  // Setting up error text state
  const [errorText, setErrorText] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      businessName: "Унесите пословно име",
      //identificationNumber: "Унесите матични број фирме, 9 цифара",
      //taxId: "Унесите ПИБ, 9 цифара",
      //identificationNumberE: "Унесите матични број фирме, 9 цифара",
      //taxIdE: "Унесите ПИБ, 9 цифара",
      firstName: "Унесите име",
      lastName: "Унесите презиме",
      //nationalId: "Унесите ЈМБГ",
      place: "Унесите место пребивалишта",
      municipality: "Унесите општину",
      zipCode: "Унесите поштански број, 5 цифара",
      street: "Унесите име улице",
      buildingNumber: "",
      phone: "Унесите број телефона",
      email: "Унесите имејл адресу",
    }
  );

  // Use effect for handling errors
  useEffect(() => {
    if (businessName.length > 0) {
      setErrorText({
        businessName: "",
      });
    }

    if (identificationNumber.match("^[0-9]{8}$")) {
      setErrorText({
        identificationNumber: "",
      });
    }

    if (taxId.match("^[0-9]{9}$")) {
      setErrorText({
        taxId: "",
      });
    }

    if (identificationNumberE.match("^[0-9]{8}$")) {
      setErrorText({
        identificationNumberE: "",
      });
    }

    if (taxIdE.match("^[0-9]{9}$")) {
      setErrorText({
        taxIdE: "",
      });
    }

    if (firstName.length > 0) {
      setErrorText({
        firstName: "",
      });
    }

    if (lastName.length > 0) {
      setErrorText({
        lastName: "",
      });
    }

    if (nationalId.match("^[0-9]{13}$")) {
      setErrorText({
        nationalId: "",
      });
    }

    if (place.length > 0) {
      setErrorText({
        place: "",
      });
    }

    if (municipality.length > 0) {
      setErrorText({
        municipality: "",
      });
    }

    if (zipCode.toString().match("^[0-9]{5}$")) {
      setErrorText({
        zipCode: "",
      });
    }

    if (street.length > 0) {
      setErrorText({
        street: "",
      });
    }

    if (phone.length > 0) {
      setErrorText({
        phone: "",
      });
    }

    if (
      email.match(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      )
    ) {
      setErrorText({
        email: "",
      });
    }

    //
    if (businessName.length < 1) {
      setErrorText({
        businessName: "Унесите пословно име",
      });
    }

    if (!identificationNumber.match("^[0-9]{8}$")) {
      setErrorText({
        identificationNumber: "Унесите матични број фирме, 8 цифара",
      });
    }

    if (!taxId.match("^[0-9]{9}$")) {
      setErrorText({
        taxId: "Унесите ПИБ, 9 цифара",
      });
    }

    if (!identificationNumberE.match("^[0-9]{8}$")) {
      setErrorText({
        identificationNumberE: "Унесите матични број фирме, 8 цифара",
      });
    }

    if (!taxIdE.match("^[0-9]{9}$")) {
      setErrorText({
        taxIdE: "Унесите ПИБ, 9 цифара",
      });
    }

    if (firstName.length < 1) {
      setErrorText({
        firstName: "Унесите име",
      });
    }

    if (lastName.length < 1) {
      setErrorText({
        lastName: "Унесите презиме",
      });
    }

    if (!nationalId.match("^[0-9]{13}$")) {
      setErrorText({
        //nationalId: "Јмбг треба да има 13 цифара",
      });
    }

    if (place.length < 1) {
      setErrorText({
        place: "Унесите место пребивалишта",
      });
    }

    if (municipality.length < 1) {
      setErrorText({
        municipality: "Унесите општину",
      });
    }

    if (!zipCode.toString().match("^[0-9]{5}$")) {
      setErrorText({
        zipCode: "Унесите поштански број, 5 цифара",
      });
    }

    if (street.length < 1) {
      setErrorText({
        street: "Унесите име улице",
      });
    }

    if (phone.length < 1) {
      setErrorText({
        phone: "Унесите број телефона",
      });
    }

    if (
      !email.match(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      )
    ) {
      setErrorText({
        email: "Унесите имејл адресу",
      });
    }
  }, [
    businessName,
    identificationNumber,
    taxId,
    identificationNumberE,
    taxIdE,
    firstName,
    lastName,
    nationalId,
    place,
    municipality,
    zipCode,
    street,
    buildingNumber,
    phone,
    email,
  ]);

  // Switch function for rendering step content
  const renderFormContent = () => {
    const step = currentStep;
    switch (step) {
      case 1:
        return (
          <ChooseAccountType
            setAccountTypeToIndividual={setAccountTypeToIndividual}
            setAccountTypeToLegalEntity={setAccountTypeToLegalEntity}
            legalEntityButtonRef={legalEntityButtonRef}
            individualButtonRef={individualButtonRef}
            buttonLegalClicked={buttonLegalClicked}
            buttonIndividualClicked={buttonIndividualClicked}
            error={error}
            errorText="fdfdf"
          />
        );
      case 2:
        if (accountType === "legal") {
          return (
            <LegalEntityBasicData
              identificationNumber={identificationNumber}
              taxId={taxId}
              handleChange={handleChange}
              businessName={businessName}
              errorText={errorText}
              businessNameError={errorText.businessName}
              identificationNumberError={errorText.identificationNumber}
              taxIdError={errorText.taxId}
            />
          );
        } else if (accountType === "individual") {
          return (
            <IndividualBasicData
              firstName={firstName}
              lastName={lastName}
              nationalId={nationalId}
              identificationNumberE={identificationNumberE}
              taxIdE={taxIdE}
              handleChange={handleChange}
              errorText={errorText}
              firstNameError={errorText.firstName}
              lastNameError={errorText.lastName}
              nationalIdError={errorText.nationalId}
              identificationNumberEError={errorText.identificationNumberE}
              taxIdEError={errorText.taxIdE}
            />
          );
        }
        break;
      case 3:
        return (
          <Address
            place={place}
            street={street}
            buildingNumber={buildingNumber}
            letter={letter}
            floor={floor}
            apartmentNumber={apartmentNumber}
            municipality={municipality}
            zipCode={zipCode}
            handleChange={handleChange}
            errorText={errorText}
            placeError={errorText.place}
            municipalityError={errorText.municipality}
            zipCodeError={errorText.zipCode}
            streetError={errorText.street}
            buildingNumberError={errorText.buildingNumber}
          />
        );

      case 4:
        return (
          <Contact
            email={email}
            phone={phone}
            handleChange={handleChange}
            errorText={errorText}
            phoneError={errorText.phone}
            emailError={errorText.email}
          />
        );
      case 5:
        return (
          <DataVerification
            accountType={accountType}
            handleSubmit={handleSubmit}
            firstName={firstName}
            lastName={lastName}
            nationalId={nationalId}
          />
        );
    }
  };

  // On click prev button
  const prevButtonClickHandler = () => {
    let currentStepVar = currentStep;
    currentStepVar = currentStep !== 1 ? currentStep - 1 : 1;
    setCurrentStep(currentStepVar);
  };

  return (
    <form className={css.boxContainer}>
      <div className={css.multiStepBox}>
        {/* Rendering specific step */}
        {renderFormContent()}

        {/* Prev and next buttons container */}
        <PrevNextButtonsContainer
          prevButtonClickHandler={prevButtonClickHandler}
          nextButtonClickHandler={nextButtonClickHandler}
          refPrevButton={prevButtonRef}
          refNextButton={nextButtonRef}
          disabledNextButton={disabledButton}
          hiddenPrev={currentStep === 1 ? true : false}
          hiddenNext={false}
        />
      </div>
    </form>
  );
};

export default MultiStepForm;
